module.exports = __webpack_public_path__ + "media/images/country_flags/bv-74df97c3a8977f38edc85938980b3767.png";